import axios from 'axios';
import router from '@/router'
import { Message } from "view-design";

//自动切换环境
// axios.defaults.baseURL = "http://localhost"
//设置超时时间
axios.defaults.timeout = 10000*10;
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.withcredentials = true

const API_PATH = '/movie';

const noAuthUrls = ["/v2/login"];

//请求拦截(请求发出前处理请求)
axios.interceptors.request.use((config) => {
    const isNoAuthRequest = noAuthUrls.some(url => config.url.includes(url));
    if (isNoAuthRequest) {
        window.sessionStorage.removeItem("token");
    }
    if (!isNoAuthRequest && window.sessionStorage.getItem('token')) {
        console.log(">>>>>>>>>>>>>>>.. 添加 Authorization 头...");
        config.headers['Authorization'] = 'Bearer ' + window.sessionStorage.getItem('token');
    }

    return config;
}, (error) => {
    console.log(error);
});

// 响应拦截器（处理响应数据）
axios.interceptors.response.use((res) => {
    //对响应数据做判断，与后台协议统一接口返回格式
    console.log("响应拦截器（处理响应数据）" + res);
    if(res.status && res.status == 200){
        if (res.data.code == 200) { //这个判断可根据实际情况修改
            Message.success(res.data.message);
        }else if(res.data.code == 202){
            Message.error(res.data.message);
            return res;
        }else if(res.data.code == 401){
            // Message.error(res.data.message);
            // 清除用户的 token 等认证信息
            router.push({ name: 'login' }); // 假设登录页的路由名称是 'login'
            // 可选：弹出提示框，告诉用户会话已过期
            console.log('您的会话已过期，请重新登录');
            return Promise.reject(res.data.message); // 中断当前请求
            // return;
        }else if(res.data.code == 403){
            Message.error(res.data.message);
            return;
        }else if(res.data.code == 500){
            Message.error(res.data.message);
            return;
        }else if(res.data.code == 4000){
            Message.error(res.data.message);
            return;
        }else if(res.data.code == 4001){
            Message.error(res.data.message);
            return;
        }else if(res.data.code == 4002){
            Message.error(res.data.message);
            return;
        }
    }
    return res;
});

// 封装get方法
function get(url, params){
    return new Promise((resolve, reject) =>{
        axios.get(url, params).then(res =>{
            resolve(res.data);
        }).catch(err =>{
            reject(err.data);
        })
    });
}

// 封装post方法
function post(url, params){
    return new Promise((resolve, reject) =>{
        axios.post(url, params).then(res =>{
            resolve(res.data);
        }).catch(err =>{
            reject(err.data);
        })
    });
}

function put(url, params) {
    return new Promise((resolve, reject) => {
        axios.put(url, params).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data);
        })
    })
}

function put_body(url, params, body) {
    return new Promise((resolve, reject) => {
        axios.put(url + params, body).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data);
        })
    })
}

function put_param(url, param) {
    return new Promise((resolve, reject) => {
        axios.put(url + param).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data);
        })
    })
}


function delete1(url, params) {
    return new Promise((resolve, reject) => {
        axios.delete(url, params).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data);
        })
    })
}

function delete_path(url, params) {
    return new Promise((resolve, reject) => {
        axios.delete(url + params).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data);
        })
    })
}

function get_path(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url + params).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data);
        })
    })
}


//对外接口
export function request({method, url, data}){
    if(method == 'get'){
        return get(API_PATH+url, data);
    } else if(method == 'get_path') {
        return get_path(API_PATH+url, data);
    } else if(method == 'post'){
        return post(API_PATH+url, data);
    }else if(method == 'put'){
        return put(API_PATH+url, data);
    }else if(method == 'delete'){
        return delete1(API_PATH+url, data);
    } else if (method == 'delete_path') {
        return delete_path(API_PATH+url, data);
    }
}

export function new_request({method, url, param, data}) {
    if (method == 'put_body') {
        return put_body(API_PATH + url, param, data);
    }
    if (method == 'put_param') {
        return put_param(API_PATH + url, param);
    }
}

export function path(url){
    return API_PATH+url;
}

/*export function request_param({method, url, data}){
    return request_param_method(API_PATH + url, data);
}*/

/*function request_param_method(url, params){
    return new Promise((resolve, reject) =>{
        axios.post(url, params).then(res =>{
            resolve(res.data);
        }).catch(err =>{
            reject(err.data);
        })
    });
}*/


export default {
    install(Vue) {
        Vue.prototype.$axios = axios;
        Vue.prototype.$request = function () {
            return request;
        }
    }
}